import $ from 'jquery'

class ScrollTop {
    constructor() {
        this.scrollTopBtn = $('.scrolltop');
        this.events();
    }

    // Events
    events() {
        $(window).on('scroll', this.scrollTopLogic.bind(this));
        this.scrollTopBtn.on('click', this.scrollTopHandler.bind(this));
    }

    scrollTopLogic() {
        const mainWindow = $(window);
        if (mainWindow.scrollTop() > mainWindow.height()) {
            this.scrollTopBtn.addClass('scrolltop--active');
        } else {
            this.scrollTopBtn.removeClass('scrolltop--active');
        }
    }

    scrollTopHandler() {
        $('html, body').stop().animate({scrollTop: 0}, 'slow', 'swing');
    }

}

export default ScrollTop;
